import * as React from 'react'
import * as ThemeUI from 'theme-ui'
import * as ReactRouter from 'react-router-dom'
import * as R from 'ramda'

import * as Herz from '@rushplay/herz'

import * as AppConfig from './app-config'
import { HtmlContent } from './html-content'
import { PageLayout } from './page-layout'
import { SubMenu } from './sub-menu'

const faqSubMenuLinks = [
  { labelKey: 'faq.submenu.my-account.label', to: '/faq/my-account' },
  { labelKey: 'faq.submenu.bonuses.label', to: '/faq/bonuses' },
  {
    labelKey: 'faq.submenu.licensing-and-security.label',
    to: '/faq/licensing-and-security',
  },
  { labelKey: 'faq.submenu.mobile.label', to: '/faq/mobile' },
  { labelKey: 'faq.submenu.payments.label', to: '/faq/payments' },
  {
    labelKey: 'faq.submenu.responsible-gaming.label',
    to: '/faq/responsible-gaming',
  },
  {
    labelKey: 'faq.submenu.technical-issues.label',
    to: '/faq/technical-issues',
  },
]

function FaqSubmenu() {
  const translate = Herz.I18n.useTranslate()
  return (
    <SubMenu>
      {faqSubMenuLinks.map((subMenuItem, index) => (
        <SubMenu.Link
          key={`${index}-${subMenuItem.labelKey}`}
          to={subMenuItem.to}
        >
          {translate(subMenuItem.labelKey)}
        </SubMenu.Link>
      ))}
    </SubMenu>
  )
}

Herz.I18n.Loader.preload(R.pluck('labelKey', faqSubMenuLinks), FaqSubmenu)

function TermsAndConditionsSubmenu() {
  const translate = Herz.I18n.useTranslate()
  const betby = AppConfig.useBetbyConfig()

  return (
    <SubMenu>
      <SubMenu.Link to="/terms-and-conditions/general">
        {translate('terms-and-conditions.submenu.general.label')}
      </SubMenu.Link>
      <SubMenu.Link to="/terms-and-conditions/welcome-offer">
        {translate('terms-and-conditions.submenu.welcome-offer.label')}
      </SubMenu.Link>
      {betby.enabled && (
        <SubMenu.Link to="/terms-and-conditions/sports">
          {translate('terms-and-conditions.submenu.sports.label')}
        </SubMenu.Link>
      )}
    </SubMenu>
  )
}

Herz.I18n.Loader.preload(
  [
    'terms-and-conditions.submenu.general.label',
    'terms-and-conditions.submenu.welcome-offer.label',
    'terms-and-conditions.submenu.sports.label',
  ],
  TermsAndConditionsSubmenu
)

function getSubMenu(page) {
  switch (page) {
    case 'terms-and-conditions':
      return <TermsAndConditionsSubmenu />
    case 'faq':
      return <FaqSubmenu />
    default:
      null
  }
}
export function StaticPage() {
  const params = ReactRouter.useParams()
  const contentRef = React.useRef(null)
  const [content, setContent] = React.useState(null)

  const page = params[0]
  const translation = `${page.replace(/\//g, '.')}.content`
  const licenseImageTranslationKey = `${page.replace(/\//g, '.')}.license-logo`

  const translate = Herz.I18n.useTranslate(
    () => [
      translation,
      licenseImageTranslationKey,
      'static.terms-and-conditions.download',
    ],
    [page]
  )

  React.useEffect(() => {
    var blob = new Blob([contentRef?.current?.innerText], {
      type: 'text/plain',
    })
    if (blob) {
      setContent(URL.createObjectURL(blob))
    }
  }, [contentRef?.current?.innerText])

  return (
    <PageLayout headerPost={getSubMenu(page.split('/')[0])}>
      <ThemeUI.Container sx={{ p: 2, height: '100%' }}>
        <ThemeUI.Box ref={contentRef}>
          <HtmlContent>
            {translate(translation, {
              logoImageSrc: translate(licenseImageTranslationKey),
            })}
          </HtmlContent>
        </ThemeUI.Box>
        {page.includes('terms-and-conditions') && (
          <ThemeUI.Box
            sx={{
              py: 5,
              textAlign: 'center',
            }}
          >
            <ThemeUI.Box
              as="a"
              download={`mychance-${page.replace(/\//g, '-')}`}
              href={content}
              sx={{
                fontWeight: '700',
                lineHeight: 'lg',
                color: 'primary-text',
              }}
            >
              {translate(`static.terms-and-conditions.download`)}
            </ThemeUI.Box>
          </ThemeUI.Box>
        )}
      </ThemeUI.Container>
    </PageLayout>
  )
}

// for @loadable/components
export default StaticPage
